var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 12.2252C3.073 12.4856 3.07304 12.9077 3.33341 13.168C3.59379 13.4284 4.01589 13.4284 4.27622 13.168L7.99971 9.44383L11.7235 13.1676C11.9838 13.428 12.406 13.428 12.6663 13.1676C12.9266 12.9073 12.9266 12.4852 12.6663 12.2248L8.94244 8.50096L12.666 4.77671C12.9263 4.51633 12.9263 4.09422 12.6659 3.8339C12.4056 3.57356 11.9834 3.5736 11.7231 3.83398L7.99958 7.55816L4.27577 3.8343C4.01542 3.57395 3.59331 3.57395 3.33296 3.8343C3.07261 4.09465 3.07261 4.51676 3.33296 4.77711L7.05691 8.50103L3.33333 12.2252Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.90d0d0f8ae04154d7faf18bb4619b979.svg";
export { ForwardRef as ReactComponent };